export default __webpack_public_path__ + "static/media/p4-6.5207dbb2.png";